import { Option, Schema } from 'effect';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';
import type * as Hydration from 'effect/unstable/reactivity/Hydration';

import { Cart as CartSchema } from '../../capability/cart/cartSchema';
import type { Cart as CartView } from '../../capability/cart/cartSchema';

/** The browser Cart atom and both server hydration paths use the same wire shape. */
export const CartResultSchema = AsyncResult.Schema({
  success: Schema.Option(CartSchema),
  error: Schema.Any,
});

export const cartResultJsonCodec = Schema.toCodecJson(CartResultSchema);

export const encodeCartResult = (cart: Option.Option<CartView>) =>
  Schema.encodeSync(cartResultJsonCodec)(AsyncResult.success(cart, { waiting: false }));

/** A failed server read supplies no snapshot. A confirmed empty Cart supplies `None`. */
export const dehydrateCartSnapshot = (
  key: string,
  read: Option.Option<Option.Option<CartView>>,
  dehydratedAt: number = Date.now()
): ReadonlyArray<Hydration.DehydratedAtomValue> =>
  Option.match(read, {
    onNone: () => [],
    onSome: (cart) => [
      {
        '~effect/reactivity/Hydration/DehydratedAtom': true,
        key,
        value: encodeCartResult(cart),
        dehydratedAt,
      },
    ],
  });
